import { loadModel } from "./viewer.js";
// import { modelData, modifyData } from "./extensions/ModelData.js";

export async function setupModelSelection(viewer, setUrn) {
  let target_model = {};
  try {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/models`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!resp.ok) {
      throw new Error(await resp.text());
    }
    const models = await resp.json();
    target_model = models[0];

    if (target_model?.urn) {
      window.location.hash = target_model.urn;
      setUrn && setUrn(target_model.urn);
      onModelSelected(viewer, target_model.urn);
    }

  } catch (err) {
    alert("Could not list models. See the console for more details.");
    console.error(err);
    return target_model;
  }
  return target_model;
}

async function onModelSelected(viewer, urn) {
  if (window.onModelSelectedTimeout) {
    clearTimeout(window.onModelSelectedTimeout);
    delete window.onModelSelectedTimeout;
  }
  window.location.hash = urn;
  try {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/models/${urn}/status`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!resp.ok) {
      throw new Error(await resp.text());
    }
    const status = await resp.json();
    switch (status.status) {
      case "n/a":
        showNotification(`Model has not been translated.`);
        break;
      case "inprogress":
        showNotification(`Model is being translated (${status.progress})...`);
        window.onModelSelectedTimeout = setTimeout(
          onModelSelected,
          5000,
          viewer,
          urn
        );
        break;
      case "failed":
        showNotification(
          `Translation failed. <ul>${status.messages
            .map((msg) => `<li>${JSON.stringify(msg)}</li>`)
            .join("")}</ul>`
        );
        break;
      default:
        const Autodesk = window.Autodesk;
        clearNotification();
        loadModel(viewer, urn, Autodesk);
        break;
    }
  } catch (err) {
    alert("Could not load model. See the console for more details.");
    console.error(err);
  }
}

// export async function modifyModel(urn, updateData, timeData){
//   try {
//     const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/models/${urn}/modify`, {
//       method:"POST",
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({data: updateData, timestamps: timeData}),
//     });
//     const responseData = await resp.json();
//     console.log("Modify Response:", responseData);
//     if (!resp.ok) {
//       throw new Error(await resp.text());
//     }
//   } catch (err) {
//     alert("Could not modify models. See the console for more details.");
//     console.error(err);
//   }
// }

// export async function modifyModel(viewer, updateData, timeData) {
//   if(!viewer || !updateData || !timeData) return;
//   if(!viewer.model) return;

//   const models = modelData;
//   const modifyLists = modifyData;
  
//   for(const [sensorType, tunnels] of Object.entries(models)) {
//     for(const [tunnel, dbId] of Object.entries(tunnels)) {
//       const sensorData = updateData.find(sensor => sensor.Sensor === sensorType);
//       if (!sensorData) continue;

//       const newValue = sensorData[tunnel]; 
//       const newTime = timeData[sensorType][tunnel];

//       if (newValue !== undefined && newTime !== undefined){
//         // console.log(`🔄 업데이트 중: ${sensorType} (${tunnel}) = ${newValue}, 측정일 = ${newTime}`);
        
//         viewer.model.getProperties(dbId, (props) => {
//           if (!props || !props.properties) return;

//           let updatedProps = [...props.properties];
//           let modifiedValueProp = false;
//           let modifiedDateProp = false;

//           for(let i=0; i < props.properties.length; i++){
//             if(modifiedValueProp && modifiedDateProp) break;

//             if(props.properties[i].displayName === modifyLists[sensorType].date){
//               updatedProps[i].displayValue = newTime;
//               modifiedDateProp = true;
//             }
//             else if(props.properties[i].displayName === modifyLists[sensorType].value){
//               updatedProps[i].displayValue = newValue;
//               modifiedValueProp = true;
//             }
//           }

//           console.log("Before Updating: ", dbId);
//           if(!viewer.getPropertyPanel()){
//             console.warn("not exist viewer.propertyPanel. Making viewer.propertyPanel!!!!!");
//             const panel = new window.Autodesk.Viewing.Private.PropertyPanel(viewer.container, "customPropertyPanel", "Custom Properties");
//             viewer.propertyPanel = panel;
//             viewer.getPropertyPanel = () => panel;
//           }

//           viewer.select([dbId]);
//           setTimeout(() => {
//             const panel = viewer.getPropertyPanel();
//             if(panel) {
//               console.log("Updating: ", dbId);
//               panel.setProperties(updatedProps);
//               panel.refresh();
//             }
//             else{
//               console.warn("not exist viewer.propertyPanel");
//             }
//           }, 600000);

//           viewer.impl.sceneUpdated(true);
//           console.log("updated");
//         });
//       }
//     }
//   }
// }

export async function GetRecentData() {
  let data = undefined;
  try {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/sensor/data`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!resp.ok) {
      throw new Error(await resp.text());
    }
    data = await resp.json();
  } catch (err) {
    alert("Failed to get data.");
    console.error(err);
  }
  return data;
}

// 특정 기간 과거 데이터 가져오기 (최대 1주일일)
export async function GetPastData(id, from, to) {
  let data = undefined;
  try {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/sensor/past`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'id': id,
        'from': from,
        'to': to
      }
    });
    if (!resp.ok) {
      throw new Error(await resp.text());
    }
    data = await resp.json();
  } catch (err) {
    alert("Failed to get past data.");
    console.error(err);
  }
  return data;
}

export async function GetWindowData() {
  let data = undefined;
  try {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/sensor/window`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      }
    });
    if (!resp.ok) {
      throw new Error(await resp.text());
    }
    data = await resp.json();
  } catch (err) {
    alert("Failed to get past data.");
    console.error(err);
  }
  return data;
}

function showNotification(message) {
  const overlay = document.getElementById("overlay");
  overlay.innerHTML = `<div class="notification">${message}</div>`;
  overlay.style.display = "flex";
}

function clearNotification() {
  const overlay = document.getElementById("overlay");
  overlay.innerHTML = "";
  overlay.style.display = "none";
}
